import { Experiments } from "@/modules/experiments/src";

/** Which entry point the user saw, per the tracking spec. */
export enum UpSellPlacement {
  review_banner = "review_banner",
  review_button = "review_button",
  review_modal = "review_modal",
}

/**
 * The LD variants are named after the UI treatment, the spec after the surface.
 * `control` and `available` have no entry point, so they have no placement.
 */
export const toUpSellPlacement = (
  variant: string | undefined
): UpSellPlacement | undefined => {
  const variants = Experiments.UPSELL_STAYS_FROM_FLIGHTS?.variants;
  if (!variant || !variants) return undefined;

  switch (variant) {
    case variants.inline:
      return UpSellPlacement.review_banner;
    case variants.sticky_bar:
      return UpSellPlacement.review_button;
    case variants.interstitial:
      return UpSellPlacement.review_modal;
    default:
      return undefined;
  }
};
